(function(){
    var section = document.currentScript && document.currentScript.closest && document.currentScript.closest('.video_and_dropdown');
    if (!section) section = document.querySelector('.video_and_dropdown');
    if (!section) return;

    // Parallax functionality
    var parallaxContainer = section.querySelector('.ctn_video[data-parallax="true"]');
    if (parallaxContainer) {
        var parallaxImage = parallaxContainer.querySelector('.parallax-image img');
        var speed = parseFloat(parallaxContainer.dataset.parallaxSpeed) || 5;
        
        function updateParallax() {
            if (!parallaxImage) return;
            
            var rect = parallaxContainer.getBoundingClientRect();
            var windowHeight = window.innerHeight;
            
            // Check if element is in viewport
            if (rect.top < windowHeight && rect.bottom > 0) {
                var scrolled = (windowHeight - rect.top) / (windowHeight + rect.height);
                var translateY = (scrolled - 0.5) * speed * 20;
                parallaxImage.style.transform = 'scale(1.2) translateY(' + translateY + 'px)';
            }
        }
        
        window.addEventListener('scroll', updateParallax, { passive: true });
        window.addEventListener('resize', updateParallax, { passive: true });
        updateParallax();
    }

    var wrap = section.querySelector('.video.video--with-overlay');

    if (!wrap) return;

    /** @type {HTMLVideoElement|null} */
    var video = wrap.querySelector('video');
    /** @type {HTMLElement|null} */
    var overlay = wrap.querySelector('.video-overlay');
    if (!video || !overlay) return;

    function play(){
        if (!overlay || !video) return;
        video.controls = true;
        try { video.play(); } catch(e) {}
    }

    overlay.addEventListener('click', play);

    video.addEventListener('play', function(){
        if (!overlay || !video) return;
        video.controls = true;
    });
})();

document.addEventListener('DOMContentLoaded', function() {
    // Función para verificar si la resolución es menor o igual a 1080px ("mobile/tablet")
    function isLargeScreen() {
        return window.innerWidth <= 1080;
    }

    // Evitar volver a adjuntar listeners en cada resize
    let dropdownsInitialized = false;

    // Función principal para inicializar los dropdowns (idempotente)
    function initDropdowns() {
        /** @type {NodeListOf<HTMLElement>} */
        const dropdownItems = document.querySelectorAll('.dropdown .item');

        // Función para cerrar todos los dropdowns
        function closeAllDropdowns() {
            dropdownItems.forEach(item => {
                if (item.classList.contains('active')) {
                    item.classList.remove('active');
                    /** @type {HTMLElement|null} */
                    const textElement = item.querySelector('.text');
                    if (textElement) {
                        textElement.style.height = '0';
                        textElement.style.opacity = '0';
                    }
                }
            });
        }

        // Función para abrir un dropdown específico
        /**
         * @param {HTMLElement} item
         */
        function openDropdown(item) {
            /** @type {HTMLElement|null} */
            const textElement = item.querySelector('.text');
            if (textElement) {
                const textHeight = textElement.scrollHeight;
                textElement.style.height = textHeight + 'px';
                textElement.style.opacity = '1';
                item.classList.add('active');
            }
        }

        // Configurar cada item (adjuntar eventos solo una vez)
        dropdownItems.forEach((item, index) => {
            /** @type {HTMLElement|null} */
            const titleElement = item.querySelector('.ctn_tlt');
            /** @type {HTMLElement|null} */
            const textElement = item.querySelector('.text');

            if (titleElement && textElement) {
                // Añadir listener solo la primera vez
                if (!titleElement.dataset.dropdownBound) {
                    titleElement.addEventListener('click', function() {
                        // Funciona tanto en desktop como en móvil
                        const isCurrentlyActive = item.classList.contains('active');

                        if (isLargeScreen()) {
                            // Móvil: comportamiento accordion (cerrar todos, abrir uno)
                            closeAllDropdowns();
                            if (!isCurrentlyActive) {
                                openDropdown(item);
                            }
                        } else {
                            // Desktop: toggle individual (no afecta a otros)
                            if (isCurrentlyActive) {
                                // Si está abierto, cerrarlo
                                item.classList.remove('active');
                                const textElement = item.querySelector('.text');
                                if (textElement && textElement instanceof HTMLElement) {
                                    textElement.style.height = '0';
                                    textElement.style.opacity = '0';
                                }
                            } else {
                                // Si está cerrado, abrirlo
                                openDropdown(item);
                            }
                        }
                    });
                    titleElement.dataset.dropdownBound = 'true';
                }

                // Cursor indicativo en ambos modos
                titleElement.style.cursor = 'pointer';

                // Configurar estilos base para dropdown
                textElement.style.overflow = 'hidden';
                textElement.style.transition = 'height 0.3s ease, opacity 0.3s ease';

                // Estado inicial por breakpoint
                if (isLargeScreen()) {
                    // Móvil: solo el primer item abierto por defecto
                    if (index === 0) {
                        openDropdown(item);
                    } else {
                        textElement.style.height = '0';
                        textElement.style.opacity = '0';
                        item.classList.remove('active');
                    }
                } else {
                    // Desktop: todos los items abiertos por defecto
                    openDropdown(item);
                }
            }
        });

        dropdownsInitialized = true;
    }

    // Inicializar dropdowns al cargar la página
    initDropdowns();

    // También inicializar/desactivar cuando cambia el tamaño de la ventana
    /** @type {number|undefined} */
    let resizeTimeout;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function() {
            // Asegurar que los listeners estén preparados la primera vez
            if (!dropdownsInitialized) {
                initDropdowns();
            } else {
                // Actualizar estilos y estados según breakpoint actual
                /** @type {NodeListOf<HTMLElement>} */
                const dropdownItems = document.querySelectorAll('.dropdown .item');
                dropdownItems.forEach((item, index) => {
                    /** @type {HTMLElement|null} */
                    const titleElement = item.querySelector('.ctn_tlt');
                    /** @type {HTMLElement|null} */
                    const textElement = item.querySelector('.text');
                    if (!textElement || !titleElement) return;

                    // Cursor indicativo en ambos modos
                    titleElement.style.cursor = 'pointer';

                    // Configurar estilos base para dropdown
                    textElement.style.overflow = 'hidden';
                    textElement.style.transition = 'height 0.3s ease, opacity 0.3s ease';

                    if (isLargeScreen()) {
                        // Móvil: solo el primer item abierto por defecto
                        if (index === 0) {
                            const textHeight = textElement.scrollHeight;
                            textElement.style.height = textHeight + 'px';
                            textElement.style.opacity = '1';
                            item.classList.add('active');
                        } else {
                            textElement.style.height = '0';
                            textElement.style.opacity = '0';
                            item.classList.remove('active');
                        }
                    } else {
                        // Desktop: todos los items abiertos por defecto
                        const textHeight = textElement.scrollHeight;
                        textElement.style.height = textHeight + 'px';
                        textElement.style.opacity = '1';
                        item.classList.add('active');
                    }
                });
            }
        }, 250); // Debounce de 250ms
    });
});